import React, { createContext, useContext } from 'react'

export interface ChatbotReferenceActions {
  /** Add PI-tag/datapoint entries to the page's current chart view. */
  addInstruments: (
    entryIds: string[],
    timeWindow?: { from: string; to: string }
  ) => void
}

const ChatbotReferenceActionsContext =
  createContext<ChatbotReferenceActions | null>(null)

export const ChatbotReferenceActionsProvider: React.FC<{
  value: ChatbotReferenceActions
  children: React.ReactNode
}> = ({ value, children }) => (
  <ChatbotReferenceActionsContext.Provider value={value}>
    {children}
  </ChatbotReferenceActionsContext.Provider>
)

export const useChatbotReferenceActionsOptional = () =>
  useContext(ChatbotReferenceActionsContext)
